<template>
    <dl class="divide-y divide-line-soft">
        <div v-for="(row, i) in rows" :key="i" class="flex items-baseline justify-between gap-4 py-2.5">
            <dt class="text-[13px] text-muted min-w-0">{{ row.label }}</dt>
            <dd class="qp-num text-[13px] font-medium text-right min-w-0 break-words" :class="toneClass(row.tone)">
                <a v-if="row.href && row.value !== dash" :href="row.href" target="_blank" rel="noopener"
                    class="text-ink hover:text-brand hover:underline">{{ row.value }}</a>
                <span v-else>{{ row.value }}</span>
                <span v-if="row.hint && row.value !== dash" class="block text-[11px] font-normal text-faint">{{ row.hint }}</span>
            </dd>
        </div>
    </dl>
</template>

<script>
import { DASH } from '@/utils/format'

export default {
    name: 'StatList',
    props: {
        // [{ label, value, tone?: 'up'|'down'|'flat', href?, hint? }]
        rows: { type: Array, default: () => [] },
    },
    data() {
        return { dash: DASH }
    },
    methods: {
        toneClass(tone) {
            if (tone === 'up') return 'text-up'
            if (tone === 'down') return 'text-down'
            return 'text-ink'
        },
    },
}
</script>
